import { TFunction } from '@framework/i18n';
import { groupValidators } from '@framework/ui/Organisms/FinalForm/validators/helpers';
import { validateEmail } from '@framework/ui/Organisms/FinalForm/validators/user/validateEmail';
import { validateRequiredFields } from '@framework/ui/Organisms/FinalForm/validators/validateRequiredFields';

const requiredFields = [
  { fieldName: 'email', fieldCaption: 'Email' },
  { fieldName: 'entryCode', fieldCaption: 'Entry Code' },
];
const email = { fieldName: 'email', fieldCaption: 'Email' };

export default (values, t: TFunction) => groupValidators(
    validateEmail({ ...email, value: values.email, message: t('invalidEmail') }),
    validateRequiredFields(requiredFields, values, (fieldName) => t('required', { field: t(fieldName) })),
  );
